module.exports = __webpack_public_path__ + "static/media/excited.c9067c87.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/icons/excited.png
// module id = 1723
// module chunks = 0